(function () {
  const form = document.querySelector('form.pdp-hero__form');
  if (!form) return;

  // Build the add-to-cart body from the plan selector's choice
  // (form.dataset.scPlan / scQty, set by sc-plan-selector.js), so no
  // other script on the page can change what gets added.
  function buildBody() {
    const fd = new FormData(form);
    if (form.dataset.scQty) {
      fd.delete('selling_plan');
      fd.delete('quantity');
      fd.delete('properties[_plan]'); // legacy tag; dropping it lets same-plan lines merge
      fd.set('quantity', form.dataset.scQty);
      if (form.dataset.scPlan) fd.set('selling_plan', form.dataset.scPlan);
    }
    return fd;
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const btn = document.getElementById('pdp-atc-btn');
    if (btn) btn.disabled = true;

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: buildBody(),
        headers: { 'Accept': 'application/javascript' }
      });
      if (!addRes.ok) throw new Error('add failed: ' + addRes.status);

      const sectionRes = await fetch('/?sections=cart-drawer');
      const sectionData = await sectionRes.json();

      if (window.eventBus && typeof window.eventBus.emit === 'function') {
        window.eventBus.emit('update:cart:drawer', { sections: sectionData });
        window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
      } else {
        document.querySelector('.js-drawer-open-right-link')?.click();
      }
    } catch (err) {
      console.error('[SC PDP ATC] Error, falling back to native submit', err);
      form.submit();
    } finally {
      if (btn) btn.disabled = false;
    }
  }, { capture: true });
})();
